import styled from 'styled-components';

export const SellersSpan = styled.span`
  margin: 0;
  font-family: "Roboto","Helvetica","Arial",sans-serif;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.43;
  letter-spacing: 0.01071em;
`;

export const BadgeList = styled.span`
  width: 100%;
  background-color: ${({background}) => background};
  padding: 3px 10px;
  border-radius: 10px;
  color: #fff;
  opacity: 0.7;
`;

